import { Box } from "@chakra-ui/react";
import React from "react";
import About from "../components/MainBodyPart/About";
import Customer from "../components/MainBodyPart/Customer";
import Features from "../components/MainBodyPart/Features";
import Footer from "../components/Footer";
import GetStart from "../components/MainBodyPart/GetStart";
import Integration from "../components/MainBodyPart/Integration";
import Learn from "../components/MainBodyPart/Learn";
import Tracktime from "../components/MainBodyPart/Tracktime";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { googleAuthHandler } from "../redux/authReducer/actions";
const Home = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);
  console.log("hello");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const img = searchParams.get("img");
  console.log(token, img);
  useEffect(() => {
    console.log(token, img);
    if (token && img) {
      dispatch(googleAuthHandler({ token, img }));
    }
  }, [token, img]);
  if (auth.isAuth) {
    return <Navigate to="/manage/client" />;
  }
  return (
    <Box>
      <About />
      <GetStart />
      <Features />
      <Integration />
      <Customer />
      <Learn />
      <Tracktime />
      <Box bgColor={"white"} height={"20px"}></Box>
      <Footer />
    </Box>
  );
};

export default Home;
